import { CustomExpandedPanel } from '@core/components/CustomExpandedPanel';
import { Typography } from '@material-ui/core';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Fragment, useState } from 'react';
import { historicoContaStyles } from './styles';

const HistoricoConta = ({ historico }) => {
  const styles = historicoContaStyles();
  const [expanded, setExpanded] = useState(true);

  const formatDate = (date) => {
    return moment(date).format('DD/MM/YYY');
  };

  const formatDateTime = (date) => {
    return moment(date).format('[no dia ]DD/MM/YYYY[ às ]HH:mm[hs.]');
  };

  const formatCurrency = (value) =>
    new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value).replace('R$', '');

  const HistoricoItem = (
    {
      item: {
        usuarioModificacao,
        dataModificacao,
        saldoInicialAnterior,
        dataSaldoInicialAnterior,
        saldoInicialAtual,
        dataSaldoInicialAtual,
      },
    },
    index
  ) => {
    const Saldo = saldoInicialAtual !== undefined && (
      <div
        className={styles.historicoItemContainer}
      >{`${usuarioModificacao} alterou o saldo inicial de ${formatCurrency(saldoInicialAnterior)} para${formatCurrency(
        saldoInicialAtual
      )} ${formatDateTime(dataModificacao)} `}</div>
    );
    const DataSaldo = dataSaldoInicialAtual !== undefined && (
      <div
        className={styles.historicoItemContainer}
      >{`${usuarioModificacao} alterou a data do saldo inicial de ${formatDate(
        dataSaldoInicialAnterior
      )} para ${formatDate(dataSaldoInicialAtual)} ${formatDateTime(dataModificacao)}`}</div>
    );

    return (
      <Fragment key={index}>
        {Saldo}
        {DataSaldo}
      </Fragment>
    );
  };

  const Body = () => {
    const [size, setSize] = useState(3);

    const hasMore = size < historico.length;

    return (
      <div>
        {historico.slice(0, size).map((item) => (
          <HistoricoItem item={item} />
        ))}
        {hasMore && (
          <Typography className={styles.viewMore}>
            <b className={styles.viewMore} onClick={() => setSize(size + 3)}>
              Ver mais
            </b>
          </Typography>
        )}
      </div>
    );
  };

  return (
    <CustomExpandedPanel
      title="Histórico de alterações de saldo"
      expanded={expanded}
      onChange={() => setExpanded(!expanded)}
    >
      <Body />
    </CustomExpandedPanel>
  );
};

HistoricoConta.propTypes = {
  historico: PropTypes.arrayOf(
    PropTypes.objectOf({
      usuarioModificacao: PropTypes.string.isRequired,
      dataModificacao: PropTypes.string.isRequired,
      saldoInicialAnterior: PropTypes.number,
      dataSaldoInicialAnterior: PropTypes.string,
      saldoInicialAtual: PropTypes.number,
      dataSaldoInicialAtual: PropTypes.string,
    })
  ),
};

export default HistoricoConta;
